import { IFinishOperation, IOperation, OPERATION_TYPE } from '../../operations/models/operations.models';
import { IWorkflowDetailResponse } from '../models/workflows.models';

/**
 * Utilidades FINISH del editor de workflows (NIF-530).
 *
 * Abrir cuando: localizar FINISH en el detalle o normalizar redirects/callbacks vacíos.
 * Sin dependencias Angular — puro y testeable.
 */

/**
 * Busca la operación FINISH en el detalle del workflow.
 *
 * @param detail - Respuesta de detalle (o parcial con `operations`)
 */
export function findFinishOperation(
	detail: Pick<IWorkflowDetailResponse, 'operations'> | undefined,
): IFinishOperation | undefined {
	return detail?.operations?.find((op: IOperation) => op.type === OPERATION_TYPE.FINISH) as
		| IFinishOperation
		| undefined;
}

/**
 * URL opcional para el API: string vacío / null → `undefined` (omite la clave).
 *
 * @param value - Redirect o callback del form
 */
export function normalizeOptionalFinishUrl(value: unknown): string | undefined {
	if (value === null || value === undefined) {
		return undefined;
	}
	const trimmed = String(value).trim();
	return trimmed.length ? trimmed : undefined;
}

/**
 * Redirects del detalle → string (vacío si no venía).
 *
 * @param value - Redirect del API
 */
export function normalizeFinishRedirectFromApi(value: unknown): string {
	return value == null ? '' : String(value);
}
